import React, { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Row, Col } from 'antd';

import { useInjectSaga } from '@utils/injectSaga';
import { useInjectReducer } from '@utils/injectReducer';
import { makeSelectUser } from '@/global.selectors';
import { getPlacesAction, getOnlineAction, getCheckInHistoryAction } from './dashboard.actions';
import reducer from './dashboard.reducer';
import saga from './dashboard.saga';

import Place from './Place';
import History from './History';
import Login from './Login';

const key = 'dashboard';

function CheckIn(props) {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });

  useEffect(() => {
    props.getPlaces();
    props.getOnline();
    props.getHistory();
  });

  return (
    <>
      <Helmet>
        <title>Chấm công</title>
      </Helmet>
      <div style={{ marginBottom: 16 }}>
        <Row>
          <Col sm={14}>
            <h2>Chấm công</h2>
          </Col>
          <Col sm={10}>
            {`Hướng dẫn bật định vị: `}
            <a
              rel="noopener noreferrer" 
              href="https://www.thegioididong.com/game-app/huong-dan-bat-dinh-vi-cho-dien-thoai-iphone-don-gian-nhat-1275167" 
              target='_blank'>
                iPhone
            </a>
            {` - `}
            <a 
              rel="noopener noreferrer"
              href="https://www.thegioididong.com/hoi-dap/cach-quan-ly-cac-ung-dung-duoc-cap-quyen-vi-tri-tr-1145044" 
              target='_blank'>
                Android
            </a>
          </Col>
        </Row>
        {props.user.id ? (
          <>
            <Place />
            <History />
          </>
        ) : <Login />}
        
      </div>
    </>
  );
}

CheckIn.propTypes = {
  getPlaces: PropTypes.func,
  getOnline: PropTypes.func,
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser()
});

const mapDispatchToProps = dispatch => ({
  getPlaces: () => dispatch(getPlacesAction()),
  getOnline: () => dispatch(getOnlineAction()),
  getHistory: () => dispatch(getCheckInHistoryAction()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(CheckIn);
